import useLenis from "../hooks/useLenis";
import { usePageKeywords } from "../lib/seo";
import { HeaderNav } from "../components/site/HeaderNav";
import { HeroSection } from "../components/site/HeroSection";
import { BrandMarquee } from "../components/site/BrandMarquee";
import { MobileService } from "../components/site/MobileService";
import { TireInquiry } from "../components/site/TireInquiry";
import { BrandsSection } from "../components/site/BrandsSection";
import { ServicesSection } from "../components/site/ServicesSection";
import { CompanyLocation } from "../components/site/CompanyLocation";
import { ShopGallery } from "../components/site/ShopGallery";
import { BlogSection } from "../components/site/BlogSection";
import { FloatingHUD } from "../components/site/FloatingHUD";
import { Footer } from "../components/site/Footer";

export default function HomePage() {
    useLenis();
    usePageKeywords("home");

    return (
        <div className="grain-overlay min-h-screen bg-[#0A1228]" data-testid="home-page">
            <HeaderNav />
            <main>
                <HeroSection />
                <BrandMarquee />
                <MobileService />
                <TireInquiry />
                <BrandsSection />
                <ServicesSection />
                <CompanyLocation />
                <ShopGallery />
                <BlogSection />
            </main>
            <Footer />
            <FloatingHUD />
        </div>
    );
}
